<template>
    <avue-crud
            :option="option"
            :data="data"
            :page="page"
            @refresh-change="refreshChange"
            @search-change="searchChange"
            @row-save="store"
            @row-update="update"
            @row-del="del"
            @size-change="sizeChange"
            @current-change="currentChange"
            :upload-before="uploadBefore"
            ref="crud"
    >
        <!--<template slot="menuLeft">-->
            <!--<el-button size="small" icon="el-icon-download" type="success" @click="excelExport('在线信箱', '用户、工号、电话、反馈对象、反馈类型、反馈内容、反馈时间、是否需要回复、回复内容、回复时间')">导出Excel</el-button>-->
        <!--</template>-->
    </avue-crud>
</template>
<script>
  import curd from './Base/Crud'

  export default {
    mixins: [curd],
    name: 'MailboxReply',
    props: ['defaultParams'],
    data() {
      return {
        url: '/mailbox/reply',
        // curd组件
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: true, // 增加按钮显隐
          addBtnText:'新增回复', // 新增按钮文案
          editBtn: false, // 修改按钮显隐
          editBtnText: '回复',
          delBtn: false, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '回复内容',
              overHidden: true,
              prop: 'content',
              span: 24,
              type: 'textarea',
              align: 'left',
            },
            {
              label: '管理员',
              prop: 'admin-username',
              display: false,
              span: 24
            },
            {
              label: '回复时间',
              prop: 'created_at',
              hidden: true,
              display: false
            }
          ]
        }
      }
    }
  }
</script>
